import { render, staticRenderFns } from "./LandingRisks.html?vue&type=template&id=a37fca52&scoped=true&"
import script from "./LandingRisks.ts?vue&type=script&lang=ts&"
export * from "./LandingRisks.ts?vue&type=script&lang=ts&"
import style0 from "./LandingRisks.scss?vue&type=style&index=0&id=a37fca52&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a37fca52",
  null
  
)

export default component.exports